import ParticleManager from '../../classes/particleManager';
import Position from '../../classes/position';
import Scene from '../../classes/scene';
import Utils from '../../classes/utils';

export default class SceneParticleDemo extends Scene {

	constructor(args) {
		super(args);
		this.pointer = true;
	}

	createSparks() {
		let scr = this.system.screen;
		let pal = this.system.palette;
		let f = this.system.factory;

		this.particles.createSparks({
			origin:new Position({
				x:scr.width*0.5,
				y:scr.height*0.5,
				xv:Utils.randomFloat(-1,1),
				yv:Utils.randomFloat(-1,1)
			}),
			color:[pal.green, pal.yellow, pal.magenta],
			power:2,
			amount:100,
			spread:50,
			expire:400,
			expireSlop:200,
			slop:5,
			minSlop:0,
			velocityInherit:2
		});
	}

	init(data) {
		this.initLayers = [
			'default',
			'overlay',
			'interface',
			'pointer',
		];
		super.init(data);

		let scr = this.system.screen;
		let pal = this.system.palette;
		let f = this.system.factory;

		this.system.controller.reset();
		let sm = this.system.sceneManager;

		this.system.display.settings.lfoMult = 11.73;


		f.button({
			x:'100% -50', y:50, scale: 1,
			text:'exit',
			align:'right',
			color: pal.red,
			onClick: () => {
				this.system.sceneManager.changeScene('sceneExample');
				this.system.audio.playSample('gui_tiny');
				this.system.audio.stopMusic();
			}
		});

		f.mask({
			x:'50%', y:'75% 200',
			shape:'0 0 800 0 800 400 0 400',
			layer:'overlay',
		});

		this.ground = f.poly({
			x:'50%', y:'75%', color:pal.white,
			shape:'0 0 800 0'
		});
		this.ground.sprite.alpha = 0.3;

		this.particles = new ParticleManager({
			scene: this
		});
		this.particles.setGroundLevel(scr.height*0.75);
		this.particles.setSparkDamping(0.1);

		f.button({
			x:'50%', y:'75% 40', scale: 1.25,
			layer:'overlay',
			text:'sparks',
			align:'center',
			color: pal.white,
			onClick: () => {
				this.createSparks();
			}
		});

		f.button({
			x:'50% -100', y:'75% 40', scale: 1.25,
			layer:'overlay',
			text:'ripples',
			align:'right',
			color: pal.white,
			onClick: () => {
				for(let r=0; r<80; r++) {
					this.particles.createRipple(
						new Position({
							x:Utils.fuzzyFloat(scr.width*0.5, 100),
							y:Utils.fuzzyFloat(scr.height*0.5, 100),
						}),
						1, // startRadius
						Utils.fuzzyFloat(5, 2), // expandRate
						Utils.fuzzyFloat(150, 50), // expire
						r*-5, // offset
						Utils.randomElement([pal.red, pal.blue]) // color
					);
				}
			}
		});

		f.button({
				x:'50% +100', y:'75% 40', scale: 1.25,
				layer:'overlay',
				text:'chladni',
				align:'left',
				color: pal.white,
				onClick: () => {
					this.createChladni();
				}
			});
	} // init


	createRipple() {
		let scr = this.system.screen;
		let pal = this.system.palette;
		let f = this.system.factory;

			for(let r=0; r<80; r++) {
				this.particles.createRipple(
					new Position({
						x:Utils.fuzzyFloat(scr.width*0.5, 100),
						y:Utils.fuzzyFloat(scr.height*0.5, 100),
					}),
					1, // startRadius
					Utils.fuzzyFloat(5, 2), // expandRate
					Utils.fuzzyFloat(150, 50), // expire
					r*-5, // offset
					Utils.randomElement([pal.red, pal.blue]) // color
				);
			}
		}

	createChladni() {
		let f = this.system.factory;
		let sm = this.system.sceneManager;
		let pal = this.system.palette;
		//this.createRipple();
		//this.createSparks();
		this.system.sceneManager.changeScene('sceneChladniPatterns');

		system.audio.stopMusic();
		system.audio.playSample('gui_select');
	}
}